import React from 'react'
import PropTypes from 'prop-types'
import { Link2 } from '../link/link.jsx'
import { ctiLinkCompound, mailToLink } from './ctiLinkCompound.js'

const Card = ({ article, page }) => {
  const { title, subtitle, publicationDate, html, LinkList, itemPrefix } =
    article
  const location = subtitle
  const content = html?.content
  const date = new Date(publicationDate).toLocaleDateString('en-us', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
  const links = LinkList.links.map((link) => {
    return ctiLinkCompound(link)
  })

  //set mailto link to be the same as pdf download
  const pdfLink = links.find((link) => {
    return link.type === 'hippo:mirror'
  })
  const emailLink = links.find((link) => {
    return link.type === 'cti:StringCompound'
  })
  emailLink.url = mailToLink(title, pdfLink.url)

  const titleLink = (title, url) => {
    return (
      <div className="u-flex u-flexAlignItemsCenter">
        <a
          href={url}
          className="u-flex u-flexAlignItemsCenter Link u-flex u-textBold"
          target="_blank"
          rel="noreferrer"
        >
          <h3
            className="u-textColorBrandLight u-textBold"
            data-analytics="insights-card-headline"
          >
            {title}
          </h3>
        </a>
      </div>
    )
  }

  const dateLine = (date, location) => {
    return (
      <span>
        <span className="u-textBold">{date}</span>
        <span className="u-marginLeft1gu u-marginRight1gu">|</span>
        {location}
      </span>
    )
  }

  return (
    <div
      id=""
      className="u-flex u-flexCol u-bgColorWhite u-decoBorderLightFull u-marginBottom5gu u-sm-sizeFull u-md-size1of3 u-lg-size1of3"
      data-analytics="insights-card"
    >
      <div className="Card u-posRelative u-flex u-flexCol u-flexAlignItemsStart u-flexAuto u-sizeFull">
        <span className="u-textBold  u-textSecondary u-textBold u-textColorLight u-marginBottom2gu u-paddingTop1gu u-borderTop u-borderColorPrimaryTemp pdf-pre-header">
          {itemPrefix}
        </span>
        <div className="u-flex u-flexCol u-flexAuto u-sizeFull u-flexAlignItemsStart">
          <div className="u-flex u-flexCol u-sizeFull u-flexAlignItemsStart">
            <div className="">{titleLink(title, pdfLink.url)}</div>
            <div className="u-marginTop2gu">
              <div className="u-marginTop2gu u-textSecondary u-textColorLight u-textSizeMsrm1 u-inline">
                {dateLine(date, location)}
              </div>
            </div>
          </div>
          <div className="u-flex u-flexCol u-flexAuto u-sizeFull">
            <div
              className="Content u-flexAuto u-paddingBottom0"
              dangerouslySetInnerHTML={{
                __html: page.rewriteLinks(content),
              }}
            ></div>
            <div>
              <hr />

              <div className="u-flex u-flexCol">
                {links.map(
                  (link, index) =>
                    link.text &&
                    link.url && (
                      <div key={index} className="u-marginTop2gu">
                        <Link2
                          url={link.url}
                          text={link.text}
                          icon={link.icon}
                          className={`u-textNoWrap u-textSizeMsrm1 u-textBrandLight u-textSecondary u-textKernLoose`}
                        />
                      </div>
                    )
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
Card.propTypes = {
  article: PropTypes.object,
  page: PropTypes.object,
}

export default Card
